import Component from '@glimmer/component';
import { t } from 'ember-intl';
import {
  HdsPageHeader,
  HdsTable,
  HdsLinkInline,
} from '@hashicorp/design-system-components/components';
import { CoreLayoutMain, BreadcrumbsContainer } from 'core/components';

/**
 * `model` has the list of HCP roles.
 * @argument model
 * @type {Object}
 */
/**
 *
 * `PageRolesList` lists the HCP Roles.
 *
 *
 * ```
 * <Page::Roles::List @model={{model}} />
 * ```
 *
 * @class PageRolesList
 *
 */
export default class PageRolesList extends Component {
  <template>
    <CoreLayoutMain>
      <:header>
        <HdsPageHeader as |PH|>
          <PH.Breadcrumb>
            <BreadcrumbsContainer />
          </PH.Breadcrumb>
          <PH.Title data-test-role-page-title>
            {{t "components.page.access-control.roles.list.title"}}
          </PH.Title>
        </HdsPageHeader>
      </:header>
      <:body>
        <section>
          <HdsTable
            @caption={{t "components.page.access-control.roles.list.title"}}
            @valign="middle"
          >
            <:head as |H|>
              <H.Tr>
                <H.Th>
                  {{t
                    "components.page.access-control.roles.list.table.headers.title"
                  }}
                </H.Th>
                <H.Th>
                  {{t
                    "components.page.access-control.roles.list.table.headers.description"
                  }}
                </H.Th>
              </H.Tr>
            </:head>
            <:body as |B|>
              {{#each @model.roles key="id" as |role|}}
                <B.Tr data-test-role-item>
                  <B.Td data-test-role-item-title>
                    <HdsLinkInline
                      class="hds-font-weight-medium"
                      @color="secondary"
                      @route="cloud.access-control.roles.detail"
                      @model={{role.id}}
                      data-test-role-item-title-link
                    >
                      {{role.title}}
                    </HdsLinkInline>
                  </B.Td>
                  <B.Td data-test-role-item-role-description>
                    {{role.description}}
                  </B.Td>
                </B.Tr>
              {{/each}}
            </:body>
          </HdsTable>
        </section>
      </:body>
    </CoreLayoutMain>
  </template>
}
